import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const isGuestModeEnabled = createSelector(membersState, (members) => members.isGuestModeEnabled);
